import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=ccbc5d2a&scoped=true"
import script from "./add-user.vue?vue&type=script&lang=ts"
export * from "./add-user.vue?vue&type=script&lang=ts"
import style0 from "./add-user.vue?vue&type=style&index=0&id=ccbc5d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbc5d2a",
  null
  
)

export default component.exports